import { useEffect } from "react";
import { useLocation, Navigate, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchUsers } from "../store/user";
import CLoader from "../components/shared/CLoader";
import roleMapping from "../data/roleMapping";
import { useTokenCheck } from '../hooks/useTokenCheck';

const hasAccess = (selectedRole, realtivePath) => {
  let userHasAccess = true;

  // BIA Team can now access details pages (removed restriction)
  // if (
  //   selectedRole === "spclty_hub_bia_team" &&
  //   realtivePath.includes("/details/")
  // ) {
  //   userHasAccess = false;
  // }

  if (
    selectedRole !== "spclty_hub_bia_team" &&
    selectedRole !== "spclty_hub_admin" &&
    selectedRole !== "spclty_hub_super_admin" &&
    selectedRole !== "spclty_hub_viewer" &&
    realtivePath.includes("/specialties")
  ) {
    userHasAccess = false;
  }

  if (
    selectedRole === "spclty_hub_viewer" &&
    realtivePath.includes("/add-specialties")
  ) {
    userHasAccess = false;
  }

  if (
    selectedRole !== "spclty_hub_bia_team" &&
    selectedRole !== "spclty_hub_admin" &&
    selectedRole !== "spclty_hub_super_admin" &&
    realtivePath.includes("/add-specialties")
  ) {
    userHasAccess = false;
  }

  if (
    selectedRole !== "spclty_hub_admin" &&
    selectedRole !== "spclty_hub_super_admin" &&
    realtivePath.includes("/admin")
  ) {
    userHasAccess = false;
  }

  if (
    selectedRole !== "spclty_hub_super_admin" &&
    realtivePath.includes("/superadmin/import")
  ) {
    userHasAccess = false;
  }

  return userHasAccess;
};

const Middleware = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const tokenAvailable = useTokenCheck();

  const realtivePath = location.pathname;

  const { roles, loader } = useSelector(({ user }) => user);
  const { statusCode } = useSelector(({ error }) => error);

  // Only fetch users if token is available
  useEffect(() => {
    if (tokenAvailable) {
      dispatch(fetchUsers());
    }
  }, [dispatch, tokenAvailable, location.pathname]); 

  useEffect(() => {
    if (statusCode) {
      navigate("/error", { state: { status: statusCode } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusCode]);

  // Show loader while waiting for token
  if (!tokenAvailable) {
    return <CLoader size={90} />;
  }

  // Don't run on auth routes
  if (realtivePath.includes("/auth/") || realtivePath.includes("/error")) {
    return children;
  }

  // Only show full-page loader if we have no user data yet (first load)
  // After first load, let the page render while security checks happen in background
  if (loader && !roles.length) {
    return <CLoader size={90} />;
  }

  if (!roles.length) {
    return <CLoader size={90} />;
  }

  let selectedRole = sessionStorage.getItem("role");
  if (roles.length && !roles.includes(selectedRole)) {
    sessionStorage.removeItem("role");
    return <Navigate to="/error" state={{ status: 401 }} />;
  }

  if (!selectedRole) {
    return <Navigate to="/error" state={{ status: 401 }} />;
  }

  if (selectedRole && !roleMapping[selectedRole]) {
    return <Navigate to="/error" state={{ status: 401 }} />;
  }

  if (!hasAccess(selectedRole, realtivePath)) {
    return <Navigate to="/unauthorized-access" />;
  }

  const BIARoutes = [
    "overview",
    "details",
    "specialties",
    "approvedspecialities",
    "userprofile",
    "unauthorized-access",
    "error",
  ];
  if (
    selectedRole === "spclty_hub_bia_team" &&
    !BIARoutes.some((route) => realtivePath.includes(route))
  ) {
    return <Navigate to="/overview" />;
  }

  return children;
};

export default Middleware;